module.exports = __webpack_public_path__ + "static/media/secretary.3e267eff.png";